import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: any;
  startDate: moment.Moment | null;
  defaultStartDate: moment.Moment | null;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  data: null,
  startDate: null,
  defaultStartDate: null,
};

const getConfigMinDateSlice = createSlice({
  name: "getConfigMinDate",
  initialState,
  reducers: {
    getConfigMinDateStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getConfigMinDateSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    updateConfigMinDate: (state, action) => {
      state.startDate = action.payload;
    },
    updateDefaultStartDate: (state, action) => {
      state.defaultStartDate = action.payload;
    },
    getConfigMinDateFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const {
  getConfigMinDateStart,
  getConfigMinDateSuccess,
  getConfigMinDateFailed,
  updateConfigMinDate,
  updateDefaultStartDate,
} = getConfigMinDateSlice.actions;

export default getConfigMinDateSlice.reducer;
